import { render, staticRenderFns } from "./LeyendaUnidades.vue?vue&type=template&id=551e9af4&scoped=true"
import script from "./LeyendaUnidades.vue?vue&type=script&lang=js"
export * from "./LeyendaUnidades.vue?vue&type=script&lang=js"
import style0 from "./LeyendaUnidades.vue?vue&type=style&index=0&id=551e9af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551e9af4",
  null
  
)

export default component.exports